module.exports = __webpack_public_path__ + "img/02.0a2334d6.png";